import { EStatus } from '../../types/context';

export const AVAILABLE_STATUS_LIST: EStatus[] = [EStatus.Loading, EStatus.Failed];

export const TITLE_MAPPING: Partial<Record<EStatus, string>> = {
  [EStatus.Failed]: 'Что-то пошло не так',
};
